<template>
  <div>
    <div
      class="dimline0"
      :class="{ bgray: isGray, pl16: !isGray }"
      v-if="isShow"
    >
      <div ref="dimline" class="dimline1">
        <p></p>
        <div class="dim-andor">
          <div :class="{ active: anded === 1 }" @click="andedFn(1)">
            {{ $t('pc_spmodel_the_and') }}
          </div>
          <div :class="{ active: anded === 2 }" @click="andedFn(2)">
            {{ $t('pc_spmodel_the_or') }}
          </div>
        </div>
      </div>
      <div ref="dimlines" class="dimline2">
        <slot></slot>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'dimline',
  data() {
    return {};
  },
  props: {
    isShow: {
      default: true,
      type: Boolean
    },
    isGray: {
      default: true,
      type: Boolean
    },
    num: {
      default: 0,
      type: Number
    },
    anded: {
      default: 0,
      type: Number
    }
  },
  methods: {
    reSetHeight() {
      this.$nextTick(() => {
        if (this.$refs.dimline && this.$refs.dimlines) {
          var target = this.$refs.dimline;
          // 获取兄弟元素的高度
          var siblingHeight = this.$refs.dimlines.querySelector('.dimension-c')
            .offsetHeight;
          console.log(siblingHeight);
          // 将兄弟元素的高度应用到目标元素上
          if (target) {
            target.style.height = siblingHeight + 'px';
          }
        }
      });
    },
    andedFn(i) {
      this.$emit('update:anded', i);
    }
  }
};
</script>
<style lang="scss" scoped>
.dimline0 {
  display: flex;
}
.bgray {
  background: #f9f9f9;
  border-radius: 5px;
}
.dimline1 {
  position: relative;
  width: 16px;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  p {
    width: 8px;
    height: 100%;
    border-right: 1px solid #d9d9d9;
  }
  .dim-andor {
    width: 26px;
    height: 36px;
    background: #fff;
    position: absolute;
    top: calc(50% - 18px);
    left: -4px;
    div {
      width: 26px;
      height: 18px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 18px;
      cursor: pointer;
    }
    .active {
      background: #436bff;
      color: #ffffff;
    }
  }
}
.dimline2 {
  flex: 1;
  margin-left: 16px;
}

.yxt-timeline-item__node,
.yxt-timeline-item__node--normal {
  top: 50% !important;
}
</style>
